import React from 'react';

// Anni costruiti dinamicamente: annualità presenti nei dati (available_years, backend)
// + SEMPRE l'anno corrente di sistema. Nessun anno hardcoded.
export const PaymentsYearSelector = ({ value, onChange, availableYears = [] }) => {
  const currentYear = new Date().getFullYear();
  const years = Array.from(new Set([...(availableYears || []), currentYear]))
    .filter((y) => Number.isInteger(y))
    .sort((a, b) => a - b);
  const opts = [...years.map((y) => ({ key: String(y), label: String(y) })), { key: 'all', label: 'Tutti' }];

  return (
    <div className="flex items-center gap-1 flex-wrap" data-testid="payments-year-selector">
      <span className="text-xs text-[#737373] mr-1">Annualità flussi:</span>
      {opts.map((o) => (
        <button
          key={o.key}
          onClick={() => onChange(o.key)}
          data-testid={`year-btn-${o.key}`}
          className={`px-3 py-1 text-sm rounded-full border transition-colors ${
            String(value) === o.key
              ? 'bg-[#FF7819] text-white border-[#FF7819]'
              : 'bg-white text-[#525252] border-slate-300 hover:border-[#FF7819]'
          }`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
};

export default PaymentsYearSelector;
